<script>
export default {
  name: 'kyeFormuListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    approveRecord(item) {
      // this.$emit('approveRecord', id);
      this.$emit('details', item);

    },
    openSaveDialog(item) {
      this.$emit('details', item);
    },
  },
};
</script>

<template>
  <tr>
    <td><b> {{ item.id }}</b> </td>
    <td @click="openSaveDialog(item)" style="cursor:pointer"> {{ item.calisanAdSoyad }} </td>
    <td> {{ item.kimlikNo }}</td>
    <td>{{ item.olusturmaTarihi|dateWithTimeView }}</td>
    <td>
      <v-btn @click="openSaveDialog(item)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-eye
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
